import {useAppContext} from "../../utils/AppContext";
import video from '../../assets/videos/maze_demo.mp4';
import cover from '../../assets/images/maze_cover.png'

const Demo = () => {
    const {
        projectData,
        screenSize,
    } = useAppContext();

    // Styles Configuration //
    const demoContainer = (!screenSize)? 'demo-container' : `demo-container demo-container${screenSize}`;
    const sectionTitle = (!screenSize)? "section-title" : `section-title section-title${screenSize}`;

    return (
        <div className={demoContainer}>
            <h2 className={sectionTitle}>{projectData.demo.title}</h2>
            <video
                className="demo-video"
                poster={cover}
                controls
            >
                <source src={video} type="video/mp4" />
            </video>
        </div>
    );

};

export default Demo;
